import { z } from 'zod';

/**
 * Zod sans compilation à la volée : il testerait sinon `new Function` au premier usage, ce que la Content-Security-Policy
 * du front interdit (script-src 'self', cf. .helm.yml). Importé en premier par main.tsx.
 */
z.config({ jitless: true });
